<template>
  <el-row v-loading="loading">
    <el-row class="padding_5px_top">
    <el-tabs
        id="rankingTab"
        v-model="activeName"       
      >
  
  <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange" style="margin-top: -8px;float: left;margin-bottom: 40px;">
            <el-checkbox name="firth" key="firth" label="firth" @click="firthClick" @change="firthChange">全部</el-checkbox>
            <el-checkbox  name="second" key="second" label="second" @click="secondClick" @change="secondChange">业绩评分</el-checkbox>
            <el-checkbox  name="third" key="third" label="third" @click="thirdClick" @change="thirdChange">规模</el-checkbox>
            <el-checkbox  name="fourth" key="fourth" label="fourth" @click="fourthClick" @change="fourthChange">资金流</el-checkbox>
            <el-checkbox  name="fifth" key="fifth" label="fifth" @click="fifthClick" @change="fifthChange">产品线</el-checkbox>
            <el-checkbox  name="sixth" key="sixth" label="sixth" @click="sixthClick" @change="sixthChange">综合星级</el-checkbox>
            <el-checkbox  name="seventh" key="seventh" label="seventh" @click="seventhClick" @change="seventhChange">管理团队</el-checkbox>
            <el-checkbox  name="eighth" key="eighth" label="eighth" @click="eighthClick" @change="eighthChange">费率</el-checkbox>
            <!-- <el-checkbox v-for="city in cities" :label="city" :key="city"><span slot="label">{{city}}</span></el-checkbox> -->
      </el-checkbox-group>
    </el-tabs>
    
    </el-row>

    <div class="line"></div> 
    <el-table
      ref="tableList"
      :data="tableData"
      border
      height="600"
      @sort-change="sortChange"
      :default-sort="{ prop: '', order: 'descending' }"
      style="width: 100%;"
      class="tableSpecial"
      @filter-change="filterChange"          
    >

      <el-table-column
        fixed
        prop="defaultSymbol"
        label="序号"
        width="70"
        :render-header="renderheaderRefreshData"             
      >
        <template scope="scope">
          <span>{{(pagination.skip)+(scope.$index + 1)}} </span>
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="companyNameCN"
        label="基金公司名称"
        min-width="200"
        class-name="gongsiClass"
        show-overflow-tooltip        
      >
      <template slot-scope="scope">
          <el-button
            @click="redirectCompanyReportDataPage(scope.row.companyId)"
            type="text"
            size="small"
          >{{ scope.row.companyNameCN }}</el-button>
        </template>
      </el-table-column>

      <el-table-column
        label=""
        align="center"
        key="1"  
        v-if="pinfenShow"            
      >
            <template slot="header">
              <span>业绩评分</span>
            </template>

          <el-table-column
            prop="classCount"
            label="参评基金数量(综合)"
            min-width="200"
            sortable="custom"            
            align="center"
          >
            <template slot-scope="scope">
               <span>{{ scope.row.classCount | fillNull(scope.row.classCount)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="companyScoreRaw"
            label="总分值(综合)"
            min-width="130"
            sortable="custom"            
            align="center"
            style="background-color:red !important;"
          >
            <template slot-scope="scope">
               <span>{{ scope.row.companyScoreRaw | fillNull(scope.row.companyScoreRaw)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sizeType"
            label="规模分类(综合)"
            min-width="170"      
            align="center"
            column-key="tag1"
            :filters="this.sizeTypeArr"
            filter-placement="bottom-end"
          >
            <template slot-scope="scope">
               <span v-if="scope.row.sizeType == 1">大型</span>
               <span v-else-if="scope.row.sizeType == 2">中型</span>
               <span v-else-if="scope.row.sizeType == 3">小型</span>
               <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="companyScoreRawRank"
            label="排名(综合)"
            min-width="120"
            sortable="custom" 
            align="center"
            class-name="pinfenClass"
          >
            <template slot-scope="scope">
               <span v-if="scope.row.sizeType == 1">{{ scope.row.companyScoreRawRank+"/"+scope.row.allBigSum | fillNull(scope.row.companyScoreRawRank)}}</span>
               <span v-else-if="scope.row.sizeType == 2">{{ scope.row.companyScoreRawRank+"/"+scope.row.allMiddleSum | fillNull(scope.row.companyScoreRawRank)}}</span>
               <span v-else-if="scope.row.sizeType == 3">{{ scope.row.companyScoreRawRank+"/"+scope.row.allSmallSum | fillNull(scope.row.companyScoreRawRank)}}</span>
               <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="eqallocclassCount"
            label="参评基金数量(偏股)"
            min-width="200"
            sortable="custom"            
            align="center"
          >
            <template slot-scope="scope">
               <span>{{ scope.row.eqallocclassCount | fillNull(scope.row.eqallocclassCount)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="eqalloccompanyScoreRaw"
            label="总分值(偏股)"
            min-width="140"
            sortable="custom"            
            align="center"
            style="background-color:red !important;"
          >
            <template slot-scope="scope">
               <span>{{ scope.row.eqalloccompanyScoreRaw | fillNull(scope.row.eqalloccompanyScoreRaw)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="eqallocsizeType"
            label="规模分类(偏股)"
            min-width="180"          
            align="center"
            column-key="tag2"
            :filters="this.eqallocSizeTypeArr"
            filter-placement="bottom-end"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.eqallocsizeType == 1">大型</span>
              <span v-else-if="scope.row.eqallocsizeType == 2">中型</span>
              <span v-else-if="scope.row.eqallocsizeType == 3">小型</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="eqalloccompanyScoreRawRank"
            label="排名(偏股)"
            min-width="130"
            sortable="custom" 
            align="center"
            class-name="pinfenClass"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.eqallocsizeType == 1">{{ scope.row.eqalloccompanyScoreRawRank+"/"+scope.row.eqallocbigSum | fillNull(scope.row.eqalloccompanyScoreRawRank)}}</span>
              <span v-else-if="scope.row.eqallocsizeType == 2">{{ scope.row.eqalloccompanyScoreRawRank+"/"+scope.row.eqallocmiddleSum | fillNull(scope.row.eqalloccompanyScoreRawRank)}}</span>
              <span v-else-if="scope.row.eqallocsizeType == 3">{{ scope.row.eqalloccompanyScoreRawRank+"/"+scope.row.eqallocsmallSum | fillNull(scope.row.eqalloccompanyScoreRawRank)}}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="fxincclassCount"
            label="参评基金数量(固收)"
            min-width="200"
            sortable="custom"            
            align="center"
          >
            <template slot-scope="scope">
               <span>{{ scope.row.fxincclassCount | fillNull(scope.row.fxincclassCount)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fxinccompanyScoreRaw"
            label="总分值(固收)"
            min-width="130"
            sortable="custom"            
            align="center"
            style="background-color:red !important;"
          >
            <template slot-scope="scope">
               <span>{{ scope.row.fxinccompanyScoreRaw | fillNull(scope.row.fxinccompanyScoreRaw)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fxincsizeType"
            label="规模分类(固收)"
            min-width="170"          
            align="center"
            column-key="tag3"
            :filters="this.fxincSizeTypeArr"
            filter-placement="bottom-end"
          >
            <template slot-scope="scope">
               <span v-if="scope.row.fxincsizeType == 1">大型</span>
               <span v-else-if="scope.row.fxincsizeType == 2">中型</span>
               <span v-else-if="scope.row.fxincsizeType == 3">小型</span>
               <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fxinccompanyScoreRawRank"
            label="排名(固收)"
            min-width="120"
            sortable="custom" 
            align="center"
            class-name="pinfenClass"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.fxincsizeType == 1">{{ scope.row.fxinccompanyScoreRawRank+"/"+scope.row.fxincbigSum | fillNull(scope.row.fxinccompanyScoreRawRank)}}</span>
              <span v-else-if="scope.row.fxincsizeType == 2">{{ scope.row.fxinccompanyScoreRawRank+"/"+scope.row.fxincmiddleSum | fillNull(scope.row.fxinccompanyScoreRawRank)}}</span>
              <span v-else-if="scope.row.fxincsizeType == 3">{{ scope.row.fxinccompanyScoreRawRank+"/"+scope.row.fxincsmallSum | fillNull(scope.row.fxinccompanyScoreRawRank)}}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
      </el-table-column>

      <el-table-column
        label="规模"
        align="center"
        key="2"  
        v-if="guimoShow"        
      >
        <el-table-column
          prop="fundSize"
          label="规模-不含货币基金(亿元)"
          min-width="200"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fundSize | fillNull(scope.row.fundSize)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fundSizeRank"
          label="排名"
          min-width="100"
          sortable="custom"
          align="center"
          class="borderLeft"              
        >
              <template slot-scope="scope">
                  <span>{{ scope.row.fundSizeRank | fillNull(scope.row.fundSizeRank)}}</span>
              </template>
        </el-table-column>
        <el-table-column
          prop="fundCount"
          label="份额数量"
          min-width="110"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fundCount | fillNull(scope.row.fundCount)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fundCountRank"
          label="排名"
          min-width="100"
          sortable="custom"
          align="center"
          class-name="guimoClass"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fundCountRank | fillNull(scope.row.fundCountRank)}}</span>
          </template>
        </el-table-column>        
      </el-table-column>

      <el-table-column
        label="资金流"
        align="center"
        key="3"  
        v-if="zijinliuShow"                           
      >
        <el-table-column
          prop="fundSizeFlow_1Y"
          label="最近一年资金流(亿元)"
          min-width="200"
          sortable="custom"
          align="center"          
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fundSizeFlow_1Y | fillNull(scope.row.fundSizeFlow_1Y)}}</span>           
          </template>
        </el-table-column>
        <el-table-column
          prop="fundSizeFlowRank_1Y"
          label="排名"
          min-width="100"
          align="center" 
          sortable="custom"                   
        > 
             <template slot-scope="scope">
                <span>{{ scope.row.fundSizeFlowRank_1Y | fillNull(scope.row.fundSizeFlowRank_1Y)}}</span>           
             </template>
        </el-table-column>
        <el-table-column
          prop="fundSizeFlowPer_1Y"
          label="最近一年资金流增长率"
          min-width="200"
          sortable="custom"
          align="center"          
        >
          <template slot-scope="scope">
                <span>{{ scope.row.fundSizeFlowPer_1Y | fillNull(scope.row.fundSizeFlowPer_1Y)}}</span><span v-if="checkDataHasValue(scope.row.fundSizeFlowPer_1Y)">%</span>           
          </template>
        </el-table-column>
        <el-table-column
          prop="fundSizeFlowPerRank_1Y"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"                    
        > 
             <template slot-scope="scope">
                <span>{{ scope.row.fundSizeFlowPerRank_1Y | fillNull(scope.row.fundSizeFlowPerRank_1Y)}}</span>           
             </template>
        </el-table-column>
        <el-table-column
          prop="fundSizeFlow_3Y"
          label="最近三年资金流(亿元)"
          min-width="190"
          sortable="custom"
          align="center"          
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fundSizeFlow_3Y | fillNull(scope.row.fundSizeFlow_3Y)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fundSizeFlowRank_3Y"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"                    
        > 
             <template slot-scope="scope">
               <span>{{ scope.row.fundSizeFlowRank_3Y | fillNull(scope.row.fundSizeFlowRank_3Y)}}</span>
             </template>
        </el-table-column>
        <el-table-column
          prop="fundSizeFlowPer_3Y"
          label="最近三年资金流增长率"
          min-width="200"
          sortable="custom"
          align="center"         
        >
          <template slot-scope="scope">
            <span>{{ scope.row.fundSizeFlowPer_3Y | fillNull(scope.row.fundSizeFlowPer_3Y)}}</span><span v-if="checkDataHasValue(scope.row.fundSizeFlowPer_3Y)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fundSizeFlowPerRank_3Y"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
          class-name="zijinliuClass"                     
        > 
             <template slot-scope="scope">
                <span>{{ scope.row.fundSizeFlowPerRank_3Y | fillNull(scope.row.fundSizeFlowPerRank_3Y)}}</span>
             </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="产品线"
        align="center"
        key="4"  
        v-if="chanpinxianShow"        
      >
        <el-table-column
          prop="equity"
          label="股票(亿元)"
          min-width="110"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.equity | fillNull(scope.row.equity)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="equityrank"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
        >
              <template slot-scope="scope">
                <span v-if="scope.row.equity != ''">{{ scope.row.equityrank | fillNull(scope.row.equityrank) }}</span>
                <span v-else-if="scope.row.equity == ''">--</span>
              </template>
        </el-table-column>
        <el-table-column
          prop="alloc"
          label="混合(亿元)"
          min-width="110"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
              <span>{{ scope.row.alloc | fillNull(scope.row.alloc) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="allocrank"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
        >
            <template slot-scope="scope">
              <span v-if="scope.row.alloc != ''">{{ scope.row.allocrank | fillNull(scope.row.allocrank) }}</span>
              <span v-else-if="scope.row.alloc == ''">--</span>
            </template>
        </el-table-column>
        <el-table-column
          prop="fxinc"
          label="固收(亿元)"
          min-width="110"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
              <span>{{ scope.row.fxinc | fillNull(scope.row.fxinc)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fxincrank"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
              <span v-if="scope.row.fxinc != ''">{{ scope.row.fxincrank | fillNull(scope.row.fxincrank) }}</span>
              <span v-else-if="scope.row.fxinc == ''">--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="mnmkt"
          label="货币(亿元)"
          min-width="110"
          sortable="custom"
          align="center"
        >
            <template slot-scope="scope">
              <span>{{ scope.row.mnmkt | fillNull(scope.row.mnmkt)}}</span>
            </template>
        </el-table-column>
        <el-table-column
          prop="mnmktrank"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
        >
            <template slot-scope="scope">
              <span v-if="scope.row.mnmkt != ''">{{ scope.row.mnmktrank | fillNull(scope.row.mnmktrank) }}</span>
              <span v-else-if="scope.row.mnmkt == ''">--</span>
            </template>
        </el-table-column>
        <el-table-column
          prop="other"
          label="其它(亿元)"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="chanpinxianClass"
        >
          <template slot-scope="scope">
              <span>{{ scope.row.other | fillNull(scope.row.other)}}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="综合星级"
        align="center"
        key="5"  
        v-if="zongheyejiShow"        
      >
        <el-table-column
          prop="star1Per"
          label="一星基金规模占比"
          min-width="160"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.star1Per | fillNull(scope.row.star1Per) }}</span><span v-if="checkDataHasValue(scope.row.star1Per)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="star2Per"
          label="两星基金规模占比"
          min-width="160"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.star2Per | fillNull(scope.row.star2Per) }}</span><span v-if="checkDataHasValue(scope.row.star2Per)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="star3Per"
          label="三星基金规模占比"
          min-width="160"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.star3Per | fillNull(scope.row.star3Per) }}</span><span v-if="checkDataHasValue(scope.row.star3Per)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="star4Per"
          label="四星基金规模占比"
          min-width="160"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.star4Per | fillNull(scope.row.star4Per)}}</span><span v-if="checkDataHasValue(scope.row.star4Per)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="star5Per"
          label="五星基金规模占比"
          min-width="160"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.star5Per | fillNull(scope.row.star5Per)}}</span><span v-if="checkDataHasValue(scope.row.star5Per)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="aumweightedStar"
          label="加权星级"
          min-width="110"
          sortable="custom"
          align="center"
          class-name="zongheyejiClass"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.aumweightedStar | fillNull(scope.row.aumweightedStar) }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="管理团队"
        align="center"
        key="6"  
        v-if="xintuozerenShow"        
      >
        <el-table-column
          prop="managerCount"
          label="基金经理人数"
          min-width="130"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.managerCount | fillNull(scope.row.managerCount)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="managerCountRank"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
        >
           <template slot-scope="scope">
                <span>{{ scope.row.managerCountRank | fillNull(scope.row.managerCountRank) }}</span>
           </template>
        </el-table-column>
        <el-table-column
          prop="managerCareerTime"
          label="基金经理平均投资管理年限"
          min-width="220"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.managerCareerTime | fillNullRound(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="managerCareerTimeRank"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
        >
            <template slot-scope="scope">
               <span>{{ scope.row.managerCareerTimeRank | fillNull(scope.row.managerCareerTimeRank) }}</span>
            </template>
        </el-table-column>
        <el-table-column
          prop="managerStayTime"
          label="基金经理平均在职时长"
          min-width="200"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.managerStayTime | fillNullRound(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="managerStayTimeRank"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
        >
            <template slot-scope="scope">
              <span>{{ scope.row.managerStayTimeRank | fillNull(scope.row.managerStayTimeRank)}}</span>
            </template>
        </el-table-column>
        <el-table-column
          prop="retention_3Y"
          label="最近三年留职率"
          min-width="200"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.retention_3Y | fillNullRound(2)}}</span><span v-if="checkDataHasValue(scope.row.retention_3Y)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="retentionRank_3Y"
          label="排名"
          min-width="100"
          align="center"
          class-name="xintuozerenClass"
          sortable="custom"
        >
            <template slot-scope="scope">
              <span>{{ scope.row.retentionRank_3Y | fillNull(scope.row.retentionRank_3Y)}}</span>
            </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="费率"
        align="center"
        key="7"  
        v-if="feilvShow"        
      >
        <el-table-column
          prop="terscore"
          label="运营费率综合得分"
          min-width="160"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.terscore | fillNull(scope.row.terscore)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="terscoreRank"
          label="排名"
          min-width="100"
          align="center"
          sortable="custom"
          class-name="feilvClass"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.terscoreRank != '0'">{{ scope.row.terscoreRank | fillNull(scope.row.terscoreRank)}}</span>
            <span v-else-if="scope.row.terscoreRank == '0'">--</span>
          </template>
        </el-table-column>
      </el-table-column>
      
    </el-table>
    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
      >
      </el-pagination>
    </el-col>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import { getFundCache, getFundRank,getCompanyEvaluate } from "../api/ranking";
import { loadingData } from "./mixin/loadingData";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const removeNameAndValue=componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const formatDecimal=componentsCommon.apiCommon.formatDecimal;
const formatCeil=componentsCommon.apiCommon.formatCeil;
const dateWithForwardSlash=componentsCommon.apiCommon.dateWithForwardSlash;
const cityOptions = ['firth','second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth'];
export default {    
    mixins: [loadingData],
    data() {
        return {
          sizeTypeArr: [{ text: '大型', value: 1 }, { text: '中型', value: 2 }, { text: '小型', value: 3 }],
          eqallocSizeTypeArr: [{ text: '大型', value: 4 }, { text: '中型', value: 5 }, { text: '小型', value: 6 }],
          fxincSizeTypeArr: [{ text: '大型', value: 7 }, { text: '中型', value: 8 }, { text: '小型', value: 9 }],
          pinfenShow:true,
          guimoShow:true,
          zijinliuShow:true,
          chanpinxianShow:true,
          zongheyejiShow:true,
          xintuozerenShow:true,
          feilvShow:true,
          isIndeterminate: true,
          checkAll: true,
          checkedCities: ['firth'],
          cities: cityOptions,
          isIndeterminate: true,
            activeName: "first",
            activeNameEqutity: "first",
            activeNameAllocation: "first",
            activeNameConvertibleBond: "first",
            activeNameBond: "first",
            activeNameMoneyMarketFunds: "first",
            activeNameMarketNeutral: "first",
            activeNameCommodities: "first",
            activeNameOthers: "first",
            dialogLoading: false,
            loading: false,
            tableData: [],
            pageSize: 0,
            selectFormat: "xlsx",
            showNoRankingIcon:false,
            tableDataLazyloading:true,
            ratingDate:'',
            sizeArr: [],   
            pagination: {
                skip: 0,
                limit: 10,
                count: 0,
            },
            params: {
                sizeStr: "",
                type: "OpenEnd",
                category: "", //"EquityFunds",
                keyword: "",
                date: "", //"2020-06-30",
                month: "", //"2020-06-30",
                quarter: "", //"2020-06-30",
                sort: "",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1,
            }
        };
    },
    watch: {
        activeName: function (val) {
            let self = this;
            switch (val) {
                case "first":                    
                    self.loadingData(
                        "EquityFunds",
                        self.params.keyword,
                        self.params.date
                    );                     
                    break;
                case "second":
                    self.loadingData(
                        "AggressiveAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "third":
                    self.loadingData(
                        "ConvertibleBond",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "fourth":
                    self.loadingData(
                        "AggressiveBondFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "fifth":
                    self.loadingData(
                        "MoneyMarketFunds",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "sixth":
                    self.loadingData(
                        "MarketNeutral",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "seventh":
                    self.loadingData(
                        "CommoditiesPreciousMetals",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "eighth":
                    self.loadingData(
                        "Others",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
            }

            self.resetPaginationParameter();
        },
        activeNameEqutity: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "EquityFunds",
                        self.params.keyword,
                        self.params.date
                    );                     
                    break;
                case "second":
                    self.loadingData(
                        "HongKongEquity",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "third":
                    self.loadingData(
                        "ShanghaiHongKongShenzhenEquity",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "fourth":
                    self.loadingData(
                        "SectorEquityHealth",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "fifth":
                    self.loadingData(
                        "SectorEquityTechnologyandCommunications",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "sixth":
                    self.loadingData(
                        "SectorEquityConsumer",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "seventh":
                    self.loadingData(
                        "SectorEquityFinancialAndRealEstate",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "CHCA000047":
                    self.loadingData(
                        "SectorEquityOther",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;                      
            }

            self.resetPaginationParameter();
        },
        activeNameAllocation: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "AggressiveAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "second":
                    self.loadingData(
                        "ModerateAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "third":
                    self.loadingData(
                        "ConservativeAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "fourth":
                    self.loadingData(
                        "FlexibleAllocationFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "fifth":
                    self.loadingData(
                        "SectorAllocationHealth",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;     
                case "sixth":
                    self.loadingData(
                        "SectorAllocationTechnologyAndCommunications",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;   
                case "seventh":
                    self.loadingData(
                        "SectorAllocationConsumer",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;   
                case "eighth":
                    self.loadingData(
                        "ShanghaiHongKongShenzhenAggressiveAllocation",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;       
                case "ninth":
                    self.loadingData(
                        "ShanghaiHongKongShenzhenConservativeAllocation",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;    
                case "tenth":
                    self.loadingData(
                        "ShanghaiHongKongShenzhenFlexibleAllocation",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;                     
                case "eleventh":
                    self.loadingData(
                        "TargetDate",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;                     
            }
            self.resetPaginationParameter();
        },
        activeNameConvertibleBond: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "ConvertibleBond",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
            }
            self.resetPaginationParameter();
        },
        activeNameBond: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "AggressiveBondFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "second":
                    self.loadingData(
                        "NormalBondFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "third":
                    self.loadingData(
                        "PureBond",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "fourth":
                    self.loadingData(
                        "ShortTermBondFund",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "CHCA000048":
                    self.loadingData(
                        "GovernmentAndPolicyBankBond",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
                case "CHCA000049":
                    self.loadingData(
                        "CorporateBond",
                        self.params.keyword,
                        self.params.date
                    );
                    break;
            }
            self.resetPaginationParameter();
        },
        activeNameMoneyMarketFunds: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "MoneyMarketFunds",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
            }
            self.resetPaginationParameter();
        },
        activeNameMarketNeutral: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "MarketNeutral",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
            }
            self.resetPaginationParameter();
        },
        activeNameCommodities: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "CommoditiesPreciousMetals",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
                case "second":
                    self.loadingData(
                        "CommoditiesOther",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;                    
            }
            self.resetPaginationParameter();
        },
        activeNameOthers: function (val) {
            let self = this;
            switch (val) {
                case "first":
                    self.loadingData(
                        "Others",
                        self.params.keyword,
                        self.params.date
                    );                    
                    break;
            }
            self.resetPaginationParameter();
        },
        showNoRankingIcon:function(val){
          return this.showNoRankingIcon;
        }
    },
    filters: {
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        fillNullRound(value, fixedDecimal) {
            if (value != undefined && value != null && value != "") {
                return formatDecimal(value, fixedDecimal);
            } else {
                return "--";
            }
        },
        fillNullCeil(value) {
            if (value != undefined && value != null && value != "") {
                return formatCeil(value);
            } else {
                return "--";
            }
        },
        fillNullNone(value1,value2) {
            if (value1 != undefined && value1 != null && value1 != "") {
                return value2;
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return dateWithForwardSlash(value);
            } else {
                return "--";
            }
        },
    },
    mounted() {
        /*const self = this;
        self.getData(self.params);*/
    },
    methods: {
      redirectCompanyReportDataPage(companyId) {
            this.$router.push({
                name: 'CompanyReport',
                // params 在刷新后会丢失；query 会保留在 URL 中，确保报告可重新加载。
                params: { companyId },
                query: { companyId }
            });
        },
      filterChange(filterObj) {
        if (this.$refs.tableList) {
          this.$refs.tableList.clearSort();
        }
        const self = this;
        if(filterObj.tag1) {
        filterObj.tag1.filter((item,i) =>{
          self.sizeArr.push(item)
        })
        this.$refs.tableList.clearFilter("tag2");
        this.$refs.tableList.clearFilter("tag3");
        }else if(filterObj.tag2) {
        filterObj.tag2.filter((item,i) =>{
          self.sizeArr.push(item)
        })
        this.$refs.tableList.clearFilter("tag1");
        this.$refs.tableList.clearFilter("tag3");
        }else if(filterObj.tag3) {
        filterObj.tag3.filter((item,i) =>{
          self.sizeArr.push(item)
        })
        this.$refs.tableList.clearFilter("tag1");
        this.$refs.tableList.clearFilter("tag2");
        }
        self.params.sizeStr = self.sizeArr.join(",");
        self.params.sort = "";
        self.getData(self.params);
        self.sizeArr = [];
      },
      firthChange(val) {
        this.checkedCities = ['firth'];
        this.pinfenShow = true;
        this.guimoShow = true;
        this.zijinliuShow = true;
        this.chanpinxianShow = true;
        this.zongheyejiShow = true;
        this.xintuozerenShow = true;
        this.feilvShow = true;
      },
      secondChange(val) {
        this.commonCheckedShow();
        this.AllShow();
      },
      thirdChange(val) {
        this.commonCheckedShow();
        this.AllShow();
      },
      fourthChange(val) {
        this.commonCheckedShow();
        this.AllShow();
      },
      fifthChange(val) {
        this.commonCheckedShow();
        this.AllShow();
      },
      sixthChange(val) {
        this.commonCheckedShow();
        this.AllShow();
      },
      seventhChange(val) {
        this.commonCheckedShow();
        this.AllShow();
      },
      eighthChange(val) {
        this.commonCheckedShow();
        this.AllShow();
      },

      commonCheckedShow() {
        this.UnAllShow();
        for(let i=0;i<this.checkedCities.length;i++) {
          if(this.checkedCities[i] === 'firth') {
            this.checkedCities.splice(i,1);
          }
          if(this.checkedCities[i] === 'second') {
            this.pinfenShow = true;
          }
          if(this.checkedCities[i] === 'third') {
            this.guimoShow = true;
          }
          if(this.checkedCities[i] === 'fourth') {
            this.zijinliuShow = true;
          }
          if(this.checkedCities[i] === 'fifth') {
            this.chanpinxianShow = true;
          }
          if(this.checkedCities[i] === 'sixth') {
            this.zongheyejiShow = true;
          }
          if(this.checkedCities[i] === 'seventh') {
            this.xintuozerenShow = true;
          }
          if(this.checkedCities[i] === 'eighth') {
            this.feilvShow = true;
          }
        }
      },

      UnAllShow() {
          this.pinfenShow=false;
          this.guimoShow=false;
          this.zijinliuShow=false;
          this.chanpinxianShow=false;
          this.zongheyejiShow=false;
          this.xintuozerenShow=false;
          this.feilvShow=false;
      },

      AllShow() {
        if(this.checkedCities.length === 0) {
          this.pinfenShow=true;
          this.guimoShow=true;
          this.zijinliuShow=true;
          this.chanpinxianShow=true;
          this.zongheyejiShow=true;
          this.xintuozerenShow=true;
          this.feilvShow=true;
          this.checkedCities = ['firth'];
        }
      },


      handleCheckAllChange(val) {
        this.checkedCities = val ? cityOptions : [];
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
      },
        getvalue(){
          const self = this;
          return self.showNoRankingIcon;
        },
        showUnidentifiedData() {
            let unidentifiedList = getNameAndValue("unidentifiedList");
            unidentifiedList = JSON.parse(unidentifiedList);
            const blob = new Blob(["\ufeff" + unidentifiedList.join("\n")], {
                type: "text/csv;charset=utf-8",
            });
            createLinkForDownload(blob, "unidentifiedList.csv");
        },
        loadingData(category, keyword, effectiveDate) {
            const self = this;
            if (category != null && category != "") {
                self.params.category = category;
                switch (category) {
                    case "EquityFunds":
                        self.activeName = "first";
                        self.activeNameEqutity = "first";                        
                        break;
                    case "AggressiveAllocationFund":
                        self.activeName = "second";
                        self.activeNameAllocation = "first";                        
                        break;
                    case "ConvertibleBond":
                        self.activeName = "third";
                        self.activeNameConvertibleBond = "first";                        
                        break;
                    case "AggressiveBondFund":
                        self.activeName = "fourth";
                        self.activeNameBond = "first";                        
                        break;
                    case "MoneyMarketFunds":
                        self.activeName = "fifth";
                        self.activeNameMoneyMarketFunds = "first";                        
                        break;
                    case "MarketNeutral":
                        self.activeName = "sixth";
                        self.activeNameMarketNeutral = "first";                        
                        break;
                    case "Commodities":
                        self.activeName = "seventh";
                        self.activeNameCommodities = "first";                        
                        break;
                    case "Others":
                        self.activeName = "eighth";
                        self.activeNameOthers = "first";                        
                        break;
                }
            }

            if (keyword != null && keyword != "") {
                self.params.keyword = keyword;
            } else {
                self.params.keyword = "";
            }

            if (effectiveDate != null && effectiveDate != "") {
                self.params.date = effectiveDate;
            } else {
                self.params.date = "";
            }
            /*self.params.month=effectiveDate;
            self.params.quarter=effectiveDate;*/
            self.getData(self.params);                                                             
        }
    }
};
</script>
<style lang="scss">
@import "../../public/sass/components/ranking";
</style>
<style scoped>
/*给table了列添加左边的border begin*/
.tableSpecial >>> table tr .xuhaoClass,
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(2),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(7),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(8),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(6),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(5),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(4),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(3),
.tableSpecial >>> table tr td:nth-child(2),
.tableSpecial >>> table tr td:nth-child(3)
 {
    border-left: 1px solid #ebeef5 !important;
}

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(2),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(7),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(8),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(9),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(6),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(5),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(4),
.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(3)
{
  border-top: 1px solid #ebeef5 !important;
}

.tableSpecial >>> table tr:nth-child(1) th:nth-last-child(2),
.tableSpecial >>> table tr .gongsiClass,
.tableSpecial >>> table tr .pinfenClass,
.tableSpecial >>> table tr .guimoClass,
.tableSpecial >>> table tr .zijinliuClass,
.tableSpecial >>> table tr .chanpinxianClass,
.tableSpecial >>> table tr .zongheyejiClass,
.tableSpecial >>> table tr .xintuozerenClass,
.tableSpecial >>> table tr .feilvClass
 {
  border-right: 1px solid #ebeef5 !important;
}
.el-table >>> .el-table__body-wrapper{
    height: 520px !important;
}
.el-table >>> .el-table__fixed-body-wrapper {
    top: 80px !important;
    height: 503px !important;
}
</style>


